import { ListQuery } from '@onArte/shared/models/common';

export class PurchasesListQuery extends ListQuery {}
